// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules

import './casestudy.scss';

const MODULE_NAME = 'casestudy';
angular

    .module(MODULE_NAME, [
    ])

    .directive('appCasestudy', ($state, $compile, $transitions) => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./casestudy.html'),
        link: ($scope, element, attrs) => {
          $transitions.onSuccess({
            to: 'casestudy',
          }, (trans) => {
            const paramsTo = trans.params();
            if (paramsTo.cid) {
            // Get data for this casestudy
              let casestudyData;
              try {
                casestudyData = require(`./casestudy-data/${ paramsTo.cid }`);
              } catch (e) {
              // Unable to locate data
                console.warn('Could not locate casetudy template for "' + paramsTo.cid + '"');
                $state.go('home');
              }
              // Update template with this data
              if (casestudyData) {
              // Scroll to top
                element.parent()[0].scrollTop = 0;
                $scope.casestudyData = casestudyData.default;
              }
            }
          });
        },
      };
    });

export default MODULE_NAME;
